module.exports = __webpack_public_path__ + "img/dizhi.b873b1e2.png";